import React from 'react'

import { useNavigation } from '@react-navigation/native'
import { Stack } from '@zet/design-system/layout'
import Pressable from '@zet/design-system/pressable'
import ArrowLeft from '@zet/design-system/svg/ArrowLeft'
import Close from '@zet/design-system/svg/Close'
import { H5 } from '@zet/design-system/typography'

type props = {
  title: string
  icon: string
}
const HeaderWithTitle = ({ title, icon = 'ArrowLeft' }: props) => {
  const navigation = useNavigation()

  const onPressClose = () => {
    if (navigation.canGoBack()) navigation.goBack()
    else navigation.replace('HomeView')
  }

  return (
    <Pressable onPress={onPressClose}>
      <Stack className="border-grays-30 bg-neutral-white100 flex-row border-b px-3 py-3">
        <Stack className="bg-grays-20 mr-3 h-5 w-5 items-center justify-center rounded">
          {icon === 'ArrowLeft' ? <ArrowLeft /> : <Close />}
        </Stack>
        <H5>{title}</H5>
      </Stack>
    </Pressable>
  )
}

export default HeaderWithTitle
